import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "sub_top" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("설치 사례"),
  /*#__PURE__*/_createElementVNode("span", null, "Installation Cases")
], -1)
const _hoisted_7 = { class: "inner gallery" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "tab_wrap" }
const _hoisted_11 = { class: "tabs" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "tab_wrap" }
const _hoisted_14 = { class: "tabs line_type" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "box" }
const _hoisted_17 = {
  key: 0,
  class: "gallery_list"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = {
  key: 1,
  class: "gallery_list"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["src"]
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  class: "modal_wrap gallery_modal",
  ref: "galleryModalRef"
}
const _hoisted_26 = { class: "modal" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn_close",
  onclick: "closeModal();"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "blind" }, "닫기")
], -1)
const _hoisted_28 = { id: "gallery_slide" }
const _hoisted_29 = { class: "img_wrap" }
const _hoisted_30 = ["src"]
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = { class: "txt mBottomTxt" }
const _hoisted_33 = { class: "pcBottomTxt" }
const _hoisted_34 = {
  class: "modal_wrap video_modal",
  ref: "videoModalRef"
}
const _hoisted_35 = { class: "modal" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn_close",
  onclick: "closeModal();"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "blind" }, "닫기")
], -1)
const _hoisted_37 = { class: "video_wrap" }
const _hoisted_38 = ["src"]
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "txt" }
const _hoisted_41 = { class: "pcBottomTxt" }


import { reactive, ref } from "vue";
import axios from "axios";

const __default__ = {
  data() {
    return {
      paging             : reactive({}),
      search             : reactive({
        itemsPerPage: 3 * 4,
        cpage       : 1,
        gateTypeCd  : this.$route.params.gateTypeCd,
        gateWorksCd : this.$route.params.gateWorksCd,
        mediaTypeCd : ""
      }),
      worksCategoryList  : reactive(new Map()),
      mediaCategoryList  : reactive(new Map()),
      gateGalleryList    : reactive({
        gateGalleryId: 0
      }),
      worksCategorySearch: reactive({
        filterType: ""
      }),
      mediaCategorySearch: reactive({
        filterType: "MDTYPE1000"
      }),
      modalTitle         : ref(""),
      modalVideoUrl      : ref(""),
      images             : []
    };
  },
  async mounted() {
    await this.init();
    await this.searchGateGalleryList();
  },
  watch  : {
    $route(to, from) {
      if (to.params.gateTypeCd !== undefined) {
        this.search.gateTypeCd = to.params.gateTypeCd;
        this.search.gateWorksCd = to.params.gateWorksCd;
        this.worksCategorySearch.filterType = "";
        this.searchGateGalleryList();
      }
    }
  },
  methods: {
    init                 : function() {
      if (this.search.gateTypeCd === undefined) {
        this.search.gateTypeCd = "GTTYPE1000";
        this.search.gateWorksCd = "GWT100";
        this.search.mediaTypeCd = "MDTYPE";
      }
    },
    setPage              : function(page) {
      if (page) {
        this.search.cpage = page;
      }
      this.searchGateGalleryList();
    },
    searchGateGalleryList: function() {
      const _this = this;
      axios.post("/api/gate-gallery/client", this.search, window.axiosOptions).then(function(response) {
        if (response.data.success === 200) {
          _this.paging = response.data.resp.paging;
          _this.worksCategoryList = response.data.resp.worksCategory;
          _this.mediaCategoryList = response.data.resp.mediaCategory;
          _this.gateGalleryList = response.data.resp.gateGalleryList;
        }
      }).catch(function(err) {
        console.error(err);
      });
    },
    openImageSlideModal  : async function(gateGalleryId, gateGalleryTitle) {
      const _this = this;
      await axios.post("/api/gate-gallery-item/list", { "gateGalleryId": gateGalleryId }, window.axiosOptions)
        .then(function(response) {
          if (response.data.success === 200) {
            _this.images = response.data.resp;
          }
        }).catch(function(err) {
          console.error(err);
        });

      this.modalTitle = gateGalleryTitle;
      this.$refs.galleryModalRef.setAttribute("style", "display: block;");

      window.callSlick("gallery_slide", 0);
    },
    showVideoModal       : function(modalTitle, videoUrl) {
      this.modalTitle = modalTitle;
      this.modalVideoUrl = videoUrl;
      if (videoUrl === null || !videoUrl.startsWith("http")) {
        alert("영상을 찾을 수 없습니다.");
        return;
      }
      this.$refs.videoModalRef.setAttribute("style", "display: block;");
    },
    worksCategoryFilter  : function(filterType) {
      this.search.gateWorksCd = filterType !== "" ? filterType : this.search.gateWorksCd.substring(0, 6);
      this.worksCategorySearch.filterType = filterType;
      this.setPage(1);
    },
    mediaCategoryFilter  : function(filterType) {
      this.mediaCategorySearch.filterType = filterType;
      this.search.mediaTypeCd = filterType;
      this.setPage(1);
    }
  }
};
import bg_sub_top from "@/assets/images/pages/bg_sub_top.jpg";
import m_bg_sub_top from "@/assets/images/pages/m_bg_sub_top.jpg";
import Paging from "./Paging";
import img_blank from "@/assets/images/pages/img_blank02.png";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(bg_sub_top),
          alt: "PC 배경이미지",
          class: "pc"
        }, null, 8, _hoisted_4),
        _createElementVNode("img", {
          src: _unref(m_bg_sub_top),
          alt: "모바일 배경이미지",
          class: "mw"
        }, null, 8, _hoisted_5),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.search.gateTypeCd === 'GTTYPE2000')
          ? (_openBlock(), _createElementBlock("h2", _hoisted_8, "차수판"))
          : (_openBlock(), _createElementBlock("h2", _hoisted_9, "진출입 안전게이트")),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("ul", _hoisted_11, [
            _createElementVNode("li", {
              class: _normalizeClass({'on' : _ctx.worksCategorySearch.filterType === ''})
            }, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.worksCategoryFilter('')))
              }, "전체")
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.worksCategoryList, (list, key) => {
              return (_openBlock(), _createElementBlock("li", {
                key: key,
                class: _normalizeClass({'on' : _ctx.worksCategorySearch.filterType === key})
              }, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: $event => (_ctx.worksCategoryFilter(key))
                }, _toDisplayString(list), 9, _hoisted_12)
              ], 2))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaCategoryList, (list, key) => {
              return (_openBlock(), _createElementBlock("li", {
                key: key,
                class: _normalizeClass({'on' : _ctx.mediaCategorySearch.filterType === key})
              }, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: $event => (_ctx.mediaCategoryFilter(key))
                }, _toDisplayString(list), 9, _hoisted_15)
              ], 2))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.search.mediaTypeCd === 'MDTYPE2000')
            ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gateGalleryList, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "video_list",
                    key: item.gateGalleryId
                  }, [
                    _createElementVNode("div", {
                      class: "img_wrap",
                      onClick: $event => (_ctx.showVideoModal(item.galleryTitle, item.videoUrl))
                    }, [
                      _createElementVNode("img", {
                        src: _unref(img_blank),
                        alt: "화면비율유지",
                        class: "temp"
                      }, null, 8, _hoisted_19),
                      _createElementVNode("img", {
                        src: item.thumbFilePath,
                        alt: item.videoUrl
                      }, null, 8, _hoisted_20)
                    ], 8, _hoisted_18),
                    _createElementVNode("p", null, _toDisplayString(item.galleryTitle), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gateGalleryList, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.gateGalleryId
                  }, [
                    _createElementVNode("div", {
                      class: "img_wrap",
                      onClick: $event => (_ctx.openImageSlideModal(item.gateGalleryId, item.galleryTitle))
                    }, [
                      _createElementVNode("img", {
                        src: _unref(img_blank),
                        alt: "화면비율유지",
                        class: "temp"
                      }, null, 8, _hoisted_23),
                      _createElementVNode("img", {
                        src: item.thumbFilePath,
                        alt: "이미지"
                      }, null, 8, _hoisted_24)
                    ], 8, _hoisted_22),
                    _createElementVNode("p", null, _toDisplayString(item.galleryTitle), 1)
                  ]))
                }), 128))
              ])),
          _createVNode(_unref(Paging), {
            paging: _ctx.paging,
            callback: _ctx.setPage
          }, null, 8, ["paging", "callback"])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "slide_item",
                key: item.id,
                ref_for: true,
                ref: 'slide_item_'+ item.id
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("img", {
                    src: _unref(img_blank),
                    alt: "화면비율유지",
                    class: "temp"
                  }, null, 8, _hoisted_30),
                  _createElementVNode("img", {
                    src: item.originFilePath,
                    alt: item.fileName
                  }, null, 8, _hoisted_31)
                ]),
                _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.modalTitle), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.modalTitle), 1)
        ])
      ], 512),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("img", {
              src: _unref(img_blank),
              alt: "화면비율유지",
              class: "mw img_temp"
            }, null, 8, _hoisted_38),
            _createElementVNode("iframe", {
              width: "1200",
              height: "675",
              src: _ctx.modalVideoUrl,
              title: "YouTube video player",
              allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
              allowfullscreen: ""
            }, null, 8, _hoisted_39)
          ]),
          _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.modalTitle), 1)
        ]),
        _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.modalTitle), 1)
      ], 512)
    ])
  ]))
}
}

})